import {ReactElement} from "react";
import {ShowcaseItem} from "../types";

export function ShowcaseItemImage(props: { showcaseItem: ShowcaseItem, style?: any }): ReactElement {
  return <img
    src={props.showcaseItem?.coverImageUrl || "/images/default_item.svg"}
    style={{
      width: "100%",
      aspectRatio: 1,
      verticalAlign: "top",
      objectFit: "cover",
      ...props.style
    }}/>;
}